import React from 'react';
import { inject, observer } from "mobx-react";


const DeliveryOptionsTextBulgarian = ({feathersStore})=> {
  return(
    <div className="terms-text">
       <h2>Доставка и изпращане</h2>
      <p>
        В нашия магазин полагаме всички усилия да обслужваме нашите клиенти. Можете да поръчвате дистанционно - по телефона или през нашия уебсайт. По-долу са описани двата най-често използвани начина за получаване на нашите продукти.
      </p>    
      <h2>
        Вземане от нашия магазин
      </h2>
      <p>
        Можете да получите поръчките си от нашия магазин на адрес {feathersStore.settings?.address}.
      </p>
      <h2>
        Доставка до вашия адрес
      </h2>
      <p>
        Ние се ангажираме да доставим вашата поръчка до мястото, което сте посочили.
      </p>
    </div>
  )
}
    
export default inject('feathersStore')(observer(DeliveryOptionsTextBulgarian));